<div class="prev-next-navigation">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <a *ngIf="previousPage" [routerLink]="previousPage.path" class="prev-link">
            <span class="nav-label">{{ 'NAVIGATION.PREVIOUS' | translate }}</span>
            <span class="nav-title">{{ previousPage.displayKey | translate }}</span>
          </a>
        </div>
        <div class="col-md-6">
          <a *ngIf="nextPage" [routerLink]="nextPage.path" class="next-link">
            <span class="nav-label">{{ 'NAVIGATION.NEXT' | translate }}</span>
            <span class="nav-title">{{ nextPage.displayKey | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>